import clsx from 'clsx';
import React, { useState } from 'react';

import linkIcon from 'images/referral/link_icon.svg';

import Button from '@components/Button';

import styles from './styles.module.scss';

const SHOW_COPIED_TEXT_DELAY = 2000;

const LinkCopy = ({
  buttonText = 'Copy Link',
  clipboardLink,
  customClass,
  trackingProps = {}, // if you want click-tracking, add properties that
  // match the EventProperties interface in "app/assets/javascripts/tracking.js"
  withInput = true,
}: {
  buttonText?: string;
  clipboardLink: string;
  customClass?: string;
  trackingProps?: { [key: string]: string };
  withInput?: boolean;
}) => {
  const [copied, setCopied] = useState<boolean>(false);

  const clickHandler = () => {
    navigator.clipboard.writeText(clipboardLink);
    setCopied(true);
    setTimeout(() => setCopied(false), SHOW_COPIED_TEXT_DELAY);
  };

  return (
    <div className={customClass}>
      {withInput && (
        <div className={styles.linkContainer}>
          <img src={linkIcon} width={15} height={15} />
          <div className={styles.link}>{clipboardLink}</div>
        </div>
      )}
      <div
        className={clsx(styles.copyButtonWrapper, { [styles.copyButtonWrapperMargin]: withInput })}
      >
        <Button
          onClick={clickHandler}
          trackingProps={{ type: 'button', ...trackingProps }}
          trackClick
          rounded="slight"
          variant="primary"
          width="full"
        >
          {copied ? 'Link Copied!' : buttonText}
        </Button>
      </div>
    </div>
  );
};

export default LinkCopy;
